import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  meta: "MBSLICE",
};

export const getMemberBenefits = createAsyncThunk(
  "memberBenefits/getMemberBenefits",
  async (payload) => {
    try {
      const response = await api.memberBenefits.getMemberBenefits(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateParentMemberBenefits = createAsyncThunk(
  "memberBenefits/updateParentMemberBenefits",
  async (payload) => {
    try {
      let id = payload?.ID;
      delete payload?.ID;
      const response = await api.memberBenefits.updateParentMemberBenefits(
        id,
        payload
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateIndividualMemberBenefits = createAsyncThunk(
  "memberBenefits/updateIndividualMemberBenefits",
  async (payload) => {
    try {
      let id = payload?.ID;
      delete payload?.ID;
      const response = await api.memberBenefits.updateIndividualMemberBenefits(
        id,
        payload
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

//v2
export const getMemberBenefitsv2 = createAsyncThunk(
  "memberBenefits/getMemberBenefitsv2",
  async (payload) => {
    try {
      const response = await api.memberBenefits.getMemberBenefitsv2(payload);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

export const updateMasterMemberBenefitsv2 = createAsyncThunk(
  "memberBenefits/updateParentMemberBenefits",
  async (payload) => {
    try {
      let id = payload?.ID;
      delete payload?.ID;
      const response = await api.memberBenefits.updateMasterMemberBenefitsv2(
        id,
        payload
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("API call failed:", error);
      throw error;
    }
  }
);

const memberBenefitsSlice = createSlice({
  name: "memberBenefits",
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

export const {} = memberBenefitsSlice.actions;

export default memberBenefitsSlice.reducer;
